import * as THREE from 'three';
import {
  CSS2DRenderer
} from 'three/examples/jsm/renderers/CSS2DRenderer';
import * as TWEEN from '../libs/TWEEN';
import Camera from './Camera';
import Grid from './Grid';
import ViewCube from './FOURcube';
import './Menu';
import './tableListeners';
import Cube from './Cube';
import TooltipCube from './TooltipCube';
import TooltipLine from './TooltipLine';
import {
  Raycast
} from './Raycaster';
import keyEvent from './EventListener';
import Draw from './DrawHintCylinder';
import UserFigure from './UserFigure';
import {
  PerspectiveCamera
} from 'three'

// 'selectStartPoint','drawOnCube','drawOnGridAndFigure'
let mode = 'selectStartPoint';

// halfSteelVisible, fullVisible, onlyCenterLines
let steelMode = 'halfSteelVisible';

let keyCode;

const pointRadius = 0.3;
const sphereGeometry = new THREE.SphereGeometry(pointRadius, 16, 16);

const scene = new THREE.Scene({
  antialias: true,
});
scene.background = new THREE.Color(0x222222);

const domElement = document.getElementById('viewport');
const renderer = new THREE.WebGLRenderer();
renderer.setSize(domElement.clientWidth, domElement.clientHeight);
renderer.setClearColor(0xffffff, 1);
domElement.appendChild(renderer.domElement);

const labelRenderer = new CSS2DRenderer();
labelRenderer.setSize(window.innerWidth, window.innerHeight);
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.top = 0;
domElement.appendChild(labelRenderer.domElement)

const cameraManager = new Camera(domElement);
let camera = cameraManager.camera;

const viewcubePerBlock = document.getElementById('viewcubePer')
const viewcubeOrthoBlock = document.getElementById('viewcubeOrtho')
const viewCubePerspective = new ViewCube(viewcubePerBlock, cameraManager, 'perspective');
const viewCubeOrthographic = new ViewCube(viewcubeOrthoBlock, cameraManager, 'orthographic');

cameraManager.onModeChange = () => {
  camera = cameraManager.camera

  if (cameraManager.mode === 'perspective') {
    viewcubePerBlock.style.display = 'block'
    viewcubeOrthoBlock.style.display = 'none'
  } else {
    viewcubePerBlock.style.display = 'none'
    viewcubeOrthoBlock.style.display = 'block'
  }
}
cameraManager.onModeChange()

const tooltipCube = new TooltipCube();
tooltipCube.cubeLabel.visible = false;
scene.add(tooltipCube.cubeLabel);

const tooltipLine = new TooltipLine();
tooltipLine.lineLabel.visible = false;
scene.add(tooltipLine.lineLabel);

let line;
let draw = new Draw()

const userFig = new UserFigure(cameraManager, draw, tooltipLine)
scene.add(userFig)

const size = 50000;
const divisions = 100;
const grid2D = new Grid(cameraManager, size, divisions);

scene.add(camera, grid2D);
window.scene = scene

const cube = new Cube(cameraManager, sphereGeometry);
cube.visible = false;
scene.add(cube);

let cubeEdgeLength = cube.size

let raycast = new Raycast(camera, scene, cube.group, grid2D.object);

let HOVERED = null

function pointOnMouseoverColor(e) {
  const previousHovered = HOVERED
  const prevLine = line
  HOVERED = null
  let mousePos = mouseNormalPosition(e.clientX, e.clientY)
  let hoverData = null
  if (mode === "drawOnGridAndFigure" || mode === "selectStartPoint") {
    hoverData = userFig.raycastPoint(mousePos);
    if (!hoverData && grid2D.visible) {
      hoverData = grid2D.raycastPoint(mousePos)
    }
  } else {
    if (cube.visible) {
      hoverData = cube.raycastPoint(mousePos)
    }
  }

  let hoveredPoint = null
  if (hoverData) {
    let pointPosition = null
    if (hoverData.object.userData.isUserPoint) {
      HOVERED = hoverData.object
      if (HOVERED !== previousHovered) {
        hoveredPoint = new THREE.Vector3()
        HOVERED.getWorldPosition(hoveredPoint)
        userFig.setPointHighlight(HOVERED, true)
      }
    } else if (hoverData.object instanceof THREE.Points) {
      HOVERED = hoverData.index
      if (HOVERED !== previousHovered) {
        hoveredPoint = grid2D.getPointPosition(HOVERED).clone()
        grid2D.setPointHighlight(HOVERED, true)
      }
    } else if (hoverData.object instanceof THREE.Mesh) {
      HOVERED = hoverData.object
      hoveredPoint = new THREE.Vector3()
      HOVERED.getWorldPosition(hoveredPoint)
      cube.setPointHighlight(HOVERED, true)
    }
  }
  // draw line
  if (hoveredPoint && HOVERED !== previousHovered) {
    if (mode !== 'selectStartPoint') {
      const activePoint = userFig.getStartPoint()
      if (activePoint) {
        line = draw.drawLine(activePoint, hoveredPoint, 'hover', steelMode)
        scene.add(line)
        scene.add(line.userData.steel)
        scene.add(line.userData.steelFaces)
      }
    }
  }

  if (previousHovered && previousHovered !== HOVERED) {
    if(prevLine){
      scene.remove(prevLine.userData.steel)
      scene.remove(prevLine.userData.steelFaces)
      scene.remove(prevLine)
    }
    
    if (typeof previousHovered === 'number') {
      grid2D.setPointHighlight(previousHovered, false)
    } else if (previousHovered.userData.isUserPoint) {
      userFig.setPointHighlight(previousHovered, false)
    } else {
      cube.setPointHighlight(previousHovered, false)
    }
  }
}

function pointOnMouseClick(e) {
  scene.remove(line)
  let mousePos = mouseNormalPosition(e.clientX, e.clientY)
  let raycasterResult = null

  if (mode === "drawOnGridAndFigure" || mode === "selectStartPoint") {
    raycasterResult = userFig.raycastPoint(mousePos);

    if (!raycasterResult && grid2D.visible) {
      raycasterResult = grid2D.raycastPoint(mousePos)
    }
  } else {
    if (cube.visible) {
      raycasterResult = cube.raycastPoint(mousePos)
    }
  }

  if (raycasterResult) {
    let pointPosition = null
    if (raycasterResult.object.userData.isUserPoint) {
      pointPosition = raycasterResult.object.position.clone()
      if (mode === "selectStartPoint") {
        userFig.setStartPoint(pointPosition)
      } else if (mode === "drawOnGridAndFigure") {
        userFig.addPoint(pointPosition)
      }
    } else {
      if (raycasterResult.object instanceof THREE.Points) {
        pointPosition = grid2D.getPointPosition(raycasterResult.index)
        if (mode === "selectStartPoint") {
          userFig.setStartPoint(null)
        }
      } else {
        cube.setPointHighlight(raycasterResult.object, false)
        pointPosition = new THREE.Vector3()
        raycasterResult.object.getWorldPosition(pointPosition)
      }
      userFig.addPoint(pointPosition, steelMode)
    }
    cube.group.position.copy(pointPosition)
    tooltipCube.setNewPosition(cubeEdgeLength, pointPosition)

    if (mode === "selectStartPoint") {
      if (userFig.points.length > 1) {
        setMode("drawOnGridAndFigure")
      } else {
        setMode("drawOnCube")
      }
    }
  }
}

function mouseNormalPosition(screenX, screenY) {
  return new THREE.Vector2(
    (screenX / window.innerWidth) * 2 - 1,
    -(screenY / window.innerHeight) * 2 + 1
  );
}

function cubeScale(e) {
  cubeEdgeLength = cube.getCubeSize(e.deltaY)
  tooltipCube.cubeLabel.element.innerText = `${cubeEdgeLength} mm`
  tooltipCube.setNewPosition(cubeEdgeLength)

}

function keyEventListener(e) {
  keyCode = keyEvent(e)
  if (keyCode === 27) {
    e.preventDefault();
    ESCPressed()
  }
  if (keyCode === 16) {
    cameraManager.enableZoom(false);
    document.addEventListener('wheel', cubeScale, false)
    document.addEventListener('keyup', () => cameraManager.enableZoom(true), false)
  }
  if (keyCode == 79) {
    toggleCameraMode()
  }
  if (keyCode == 85) {
    let pos = userFig.undoFunction()
    cube.group.position.copy(pos)
    tooltipCube.setNewPosition(undefined,pos)
  }
}

function toggleCameraMode() {
  cameraManager.toggleMode()
}

function ESCPressed() {
  let newMode = null
  if (mode === 'drawOnGridAndFigure' || mode === 'selectStartPoint') {
    newMode = 'drawOnCube';
  } else if (mode === 'drawOnCube') {
    newMode = 'selectStartPoint';
  }

  setMode(newMode)
}

function setMode(newMode) {
  console.log('set mode', newMode)
  mode = newMode
  if (mode === 'drawOnGridAndFigure' || mode === 'selectStartPoint') {
    grid2D.showPoints();
    cube.visible = false;
    tooltipCube.cubeLabel.visible = false;
  } else if (mode === 'drawOnCube') {
    grid2D.hidePoints();
    cube.visible = true;
    tooltipCube.cubeLabel.visible = true;
  }
}

function changeSteelVisibility() {
  cameraManager.enableZoom(false)
  if (steelMode === 'halfSteelVisible') {
    steelMode = 'fullVisible'
  } else if (steelMode === 'fullVisible') {
    steelMode = 'onlyCenterLines'
  } else if (steelMode === 'onlyCenterLines') {
    steelMode = 'halfSteelVisible'
  }
  userFig.changeViewMode(steelMode)
}

document.addEventListener('mousemove', pointOnMouseoverColor, false);
document.addEventListener('click', pointOnMouseClick, false);
document.addEventListener('keydown', keyEventListener, false);
document.addEventListener('mousedown', e => e.button == 2 ? changeSteelVisibility() : 0, false)
document.addEventListener('mouseup', e => e.button == 2 ? cameraManager.enableZoom(true) : 0, false)
let scaleFactor = 50;
let vec = new THREE.Vector3();

function ObjectsScale() {
  let scale = scaleFactor
  if (cameraManager.camera instanceof PerspectiveCamera) {
    scale = vec.subVectors(cameraManager.controls.target, camera.position).length() / scaleFactor
  } else {
    scale = (1 / cameraManager.camera.zoom) * scaleFactor
  }
  cube.group.children.forEach(i => {
    i.scale.setScalar(scale)
  })
  userFig.setPointsSize(scale)
}

let processedCameraDistance = camera.position.distanceTo(cameraManager.controls.target)
ObjectsScale()
cameraManager.onCameraUpdate = () => {
  const currentCameraDistance = (cameraManager.camera instanceof PerspectiveCamera) ? camera.position.distanceTo(cameraManager.controls.target) : cameraManager.camera.zoom
  if (Math.abs(currentCameraDistance - processedCameraDistance) > 0.0001) {
    ObjectsScale()
    processedCameraDistance = currentCameraDistance
  }
}

function animate(time) {
  requestAnimationFrame(animate);
  renderer.render(scene, camera);
  cameraManager.update();
  TWEEN.update(time);
  labelRenderer.render(scene, camera);
}
animate();
export {
  scene
}